import script from "./PCPartArticlesPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartArticlesPopup.vue?vue&type=script&setup=true&lang=js"

import "./PCPartArticlesPopup.vue?vue&type=style&index=0&id=1fa81ca7&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa81ca7"]])

export default __exports__